import { Box } from '@chakra-ui/react';
import {
  ISelect,
  removeEmptyQueryParams,
  TeamMenu,
  TeamTable,
} from '@devd-client/devd/components';
import { useEffect, useState } from 'react';

interface TeamTabProps {
  team: string;
  setTeam: (team: string) => void;
}

export const TeamTab = ({ team, setTeam }: TeamTabProps) => {
  const initialSelectedTeam =
    team && team !== 'Organisation'
      ? { value: team, label: team }
      : { value: '', label: 'Organisation' };
  const [selectedTeam, setSelectedTeam] = useState(initialSelectedTeam);

  useEffect(() => {
    team &&
      setSelectedTeam(
        team === 'Organisation'
          ? { value: '', label: 'Organisation' }
          : { value: team, label: team }
      );
  }, []);

  useEffect(() => {
    if (typeof selectedTeam !== 'undefined') {
      if (selectedTeam.label === 'Organisation') {
        setTeam('');
        removeEmptyQueryParams({ team: '' });
      } else {
        setTeam(selectedTeam.value);
      }
    }
  }, [selectedTeam.value]);

  const handleTeamSelection = (teamObj: ISelect) => {
    setSelectedTeam(teamObj);
    if (teamObj.value) {
      setTeam(teamObj.value);
    } else {
      removeEmptyQueryParams({ team: '' });
    }
  };

  return (
    <Box>
      <TeamMenu
        selectedTeam={selectedTeam}
        handleSelectedTeam={handleTeamSelection}
        noDefault
        hideShowDetails
      />
      <TeamTable teamId={selectedTeam.value} componentOrigin="goals" />
    </Box>
  );
};
